"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVENTORY_STATUS = exports.INVENTORY_COUNTING_STATUS = exports.INVENTORY_BIZ_TYPE_ORDER = exports.INVENTORY_BIZ_TYPES = void 0;
var INVENTORY_STATUS = exports.INVENTORY_STATUS = {
  0: '停用',
  1: '启用'
};
var INVENTORY_BIZ_TYPES = exports.INVENTORY_BIZ_TYPES = {
  IN: '入库',
  OUT: '出库',
  UNPACK_OUT: '拆箱出库',
  UNPACK_IN: '拆箱单品入库',
  CHECK_ADJUST: '盘库库存调整'
};
var INVENTORY_BIZ_TYPE_ORDER = exports.INVENTORY_BIZ_TYPE_ORDER = ['IN', 'OUT', 'UNPACK_OUT', 'UNPACK_IN', 'CHECK_ADJUST'];
var INVENTORY_COUNTING_STATUS = exports.INVENTORY_COUNTING_STATUS = {
  0: '待处理',
  1: '已完成'
};